var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_239_1458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.50001 12.4167C3.50839 12.4167 1.08334 9.99162 1.08334 7C1.08334 4.57441 2.67747 2.52149 4.87501 1.83141V2.98191C3.94384 3.36002 3.17298 4.04992 2.69429 4.9336C2.2156 5.81728 2.05882 6.83983 2.25077 7.82633C2.44272 8.81284 2.97148 9.702 3.74659 10.3417C4.5217 10.9814 5.49501 11.332 6.50001 11.3333C7.36331 11.3333 8.20694 11.0755 8.9228 10.593C9.63867 10.1105 10.1942 9.42521 10.5181 8.625H11.6686C10.9785 10.8225 8.92559 12.4167 6.50001 12.4167ZM11.8896 7.54166L5.95834 7.54166L5.95834 1.61041C6.13655 1.59254 6.31747 1.58333 6.50001 1.58333C9.49164 1.58333 11.9167 4.00837 11.9167 7C11.9167 7.18254 11.9075 7.36345 11.8896 7.54166ZM7.04168 2.70024L7.04168 6.45833L10.7998 6.45833C10.6792 5.5037 10.2445 4.6163 9.56409 3.93591C8.8837 3.25553 7.99631 2.82081 7.04168 2.70024Z",
    fill: "#673C8E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_239_1458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPie);
export default __webpack_public_path__ + "static/media/pie.bd94f32d6596ff70c4cf2e0f092d94ad.svg";
export { ForwardRef as ReactComponent };